import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalBasicForm
    from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/components/modal-basic-form/configuration-automation-grossing-shelf-sample-type-and-shelf-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState,
    initialConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState
} from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/components/modal/configuration-automation-grossing-shelf-sample-type-and-shelf-modal.model'
import {
    ConfigurationShelfSampleTypeAssignmentCreateRequest,
    ConfigurationShelfSampleTypeAssignmentPatchInBatchRequest,
    ConfigurationShelfSampleTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.dto'

@Component({
    components: {
        ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalBasicForm
    }
})
export default class ConfigurationAutomationGrossingShelfSampleTypeAndShelfModal extends Vue {
    @Ref() readonly sampleTypeAndShelfModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationShelfSampleTypeAssignmentCreateRequest {
        return {
            sampleTypeId: this.state.shelfSampleTypeAssignment.sampleType?.id!,
            virtualShelf: this.state.shelfSampleTypeAssignment.virtualShelf?.code!
        }
    }

    @Emit()
    update(): ConfigurationShelfSampleTypeAssignmentPatchInBatchRequest {
        return {
            id: this.state.shelfSampleTypeAssignment.id!,
            virtualShelf: this.state.shelfSampleTypeAssignment.virtualShelf?.code
        }
    }

    state: ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState

    get updateMode(): boolean {
        return !!this.state.shelfSampleTypeAssignment?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState()
    }

    async show(shelfSampleTypeAssignment?: ConfigurationShelfSampleTypeAssignmentResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState()
        if (shelfSampleTypeAssignment) {
            this.state.shelfSampleTypeAssignment = shelfSampleTypeAssignment
        }

        this.sampleTypeAndShelfModal.show()
    }

    hide(): void {
        this.sampleTypeAndShelfModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.shelfSampleTypeAssignment) {
                if (this.updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
